var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn btn-outline-success btn-xs",
        on: { click: _vm.open },
      },
      [_vm._v(_vm._s(_vm.text ?? "Согласовать"))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }